package empiresmp.components.alert

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.BoxScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.layout.Surface
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.percent
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette

@Composable
fun AlertDialog(
    modifier: Modifier = Modifier,
    open: Boolean,
    onDismiss: (() -> Unit)? = null,
    content: @Composable BoxScope.() -> Unit
) {
    val theme = LocalSitePalette.current

    ClosableOverlay(open = open) {
        Surface(
            modifier = modifier
                .height(100.percent)
                .width(100.percent)
                .borderRadius(theme.dimens.S)
                .backgroundColor(theme.colors.colorPrimaryVariant.toRgb().copy(alpha = 200))
                .padding(theme.dimens.S)
                .onClick { onDismiss?.invoke() }
                .overflow(Overflow.Auto)
                .position(Position.Absolute)
                .scrollBehavior(ScrollBehavior.Auto)
                .overflow(Overflow.Visible),
            contentAlignment = Alignment.Center
        ) {
            Box(
                modifier = Modifier
                    .width(100.percent)
                    .height(100.percent)
                    .borderRadius(theme.dimens.S)
                    .padding(theme.dimens.M),
                contentAlignment = Alignment.Center,
                content = content
            )
//            Column(
//                modifier = Modifier
//                    .width(100.percent)
//                    .height(100.percent)
//            ) {
//
//
//                onDismiss?.let {
//                    Spacer()
//                    Box(
//                        modifier = Modifier.fillMaxWidth().margin(top = theme.dimens.S),
//                        contentAlignment = Alignment.Center
//                    ) {
//                        FilledText(
//                            modifier = Modifier.fillMaxWidth(),
//                            text = "Закрыть",
//                            fillColor = theme.colors.colorError,
//                            textColor = theme.colors.colorOnSecondary,
//                            onClick = { onDismiss.invoke() }
//                        )
//                    }
//                }
//            }
        }
    }
}
